import { render, staticRenderFns } from "./CandidatesChart.vue?vue&type=template&id=633aae9d"
import script from "./CandidatesChart.vue?vue&type=script&lang=js"
export * from "./CandidatesChart.vue?vue&type=script&lang=js"
import style0 from "./CandidatesChart.vue?vue&type=style&index=0&id=633aae9d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports